import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
// config Rtk query for using fetching endpoints

export const apiSlice = createApi({
  reducerPath: 'api',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_API_URL}/api`,
    credentials:'same-origin',
    prepareHeaders: async (headers) => {
      const token =  localStorage.getItem('@jwt-token')
      if (token) {
        headers.set('authorization', `Bearer ${token}`)
      }
      return headers
    },
  }),
  // tag caches
  tagTypes: [
    'Admin',
    'Organization',
    'SchoolDistrict',
    'HighSchool',
    'University',
    'AdminSearch',
    'Project',
    'Category',
    'SubCategory',
    'Team',
    'Student',
    'Experience',
    'CompletionType',
    'ExperienceCard',
    'StudentCompletionPhoto',
    'LearnerSetting',
    'Shop',
    'RaffelTicket',
    'ProfileChart',
    'LeaderBoard',
    'ExperienceStudent',
    'Recent',
    'Award',
    'Bag',
    'Inventory',
    'Xp',
    'CourseEnrollment',
    'GemStudent',
    'Fuses',
    'Crystal',
    'StartChart'
  ],

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  endpoints: (builder) => ({}),
});
